<div class="contracts-container">
  <h1>Contrats</h1>

  <div class="search-container">
    <div class="text-input-search-container">
      <input
        class="search-input"
        #inputElement
        type="text"
        [(ngModel)]="inputValue"
        [placeholder]="'PRM, Nom, Numéro, Titulaire, Site'"
        (keydown.enter)="getContractsSearch(inputElement.value.trim())"
        data-testid="search-input"
      />
      <app-icon
        class="icon-search-input"
        phosphorClass="ph-magnifying-glass"
        [size]="IconSize.medium"
        [iconStyle]="Style.bold"
      ></app-icon>
    </div>
    <div class="filter-container">
      <app-date-range-picker
        [label]="'Filtrer la'"
        [showFilterSelect]="true"
        [startDate]="rangeStart"
        [endDate]="rangeEnd"
        (startDateChange)="onStartDateChanged($event)"
        (endDateChange)="onEndDateChanged($event)"
        (filterChange)="onFilterChanged($event)"
        [filterOptions]="filterOptions"
        [selectedFilter]="selectedFilter"
      ></app-date-range-picker>
    </div>
    <div class="action-section">
      <app-button
        data-testid="export-button"
        [isDisabled]="isLoading"
        class="spacement-icon"
        (onclick)="exportContracts()"
      >
        <app-icon
          [phosphorClass]="'ph-export'"
          tooltipText="Exporter les contrats"
          [tooltipPosition]="TooltipPosition.left"
        ></app-icon>
      </app-button>
      <app-button data-testid="export-button" [isLoading]="isExportLoading" (onclick)="exportContractsFactures()">
        @if (!isExportLoading) {
          <app-icon
            phosphorClass="ph-invoice"
            tooltipText="Exporter les contrats/factures"
            [tooltipPosition]="TooltipPosition.left"
          ></app-icon>
        }
      </app-button>
    </div>
  </div>

  <app-base-table
    data-testid="contracts-table"
    id="contracts-table"
    [tableLayoutAuto]="true"
    [source]="contractsSourceSearch"
    [isLoading]="isLoading"
  >
    <ng-container>
      <tr appRow *appRowHeaders></tr>
      <tr appRow class="readOnly" *appRowCells="let data; let i = index"></tr>
    </ng-container>

    <ng-container *appColumn="'name'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Nom" type="sort" field="name"></app-column-header>
      </th>
      <td data-testid="contract-name" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.name"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'number'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Numéro" type="sort" field="number"></app-column-header>
      </th>
      <td data-testid="contract-number" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.number"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'producer'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Titulaire" type="sort" field="producer"></app-column-header>
      </th>
      <td data-testid="contract-producer" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.producer.name"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'site'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Site" type="sort" field="site"></app-column-header>
      </th>
      <td data-testid="contract-site" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.site.name"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'prm'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="PRM" type="sort" field="prm"></app-column-header>
      </th>
      <td data-testid="contract-prm" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.prm"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'formulaLabel'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header
          name="Formule"
          type="filter"
          field="formulaLabel"
          [filterItems]="filterItems.formulaLabel!"
        ></app-column-header>
      </th>
      <td data-testid="contract-formula" appCell appSticky *appTableCell="let data">
        <div class="d-flex align-items-center">
          <span [innerHTML]="data.formulaLabel"></span>
          @if(data.negativePayment === true){
            <app-badge
              label="H-"
              [backgroundColor]="Color.danger100">
            </app-badge>
          }
        </div>
      </td>
    </ng-container>

    <ng-container *appColumn="'typeBill'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header
          name="Type"
          type="filter"
          [filterItems]="filterItems.typeBill!"
          field="typeBill"
          [filterTranslate]="mapTypeBill"
        ></app-column-header>
      </th>
      <td data-testid="contract-type" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="mapTypeBill(data.typeBill)"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'startDate'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Date de début" type="sort" field="startDate"></app-column-header>
      </th>
      <td data-testid="contract-start" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.startDate | date: 'dd/MM/yyyy'"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'endDate'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Date de fin" type="sort" field="endDate"></app-column-header>
      </th>
      <td data-testid="contract-end" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.endDate | date: 'dd/MM/yyyy'"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'terminationDate'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Date de résiliation" type="sort" field="terminationDate"></app-column-header>
      </th>
      <td data-testid="contract-termination" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="(data.terminationDate | date: 'dd/MM/yyyy') || '-'"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'updatedAt'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Date de modification" type="sort" field="updatedAt"></app-column-header>
      </th>
      <td data-testid="contract-updated" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="(data.updatedAt | date: 'dd/MM/yyyy HH:mm' : 'Europe/Paris') || '-'"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'contacts'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header
          name="Contacts"
          type="sort"
          [filterItems]="filterItems.contacts!"
          field="contacts"
        ></app-column-header>
      </th>
      <td data-testid="contract-contacts" appCell appSticky *appTableCell="let data; let i = index">
        <div class="tooltip-wrapper" (mouseenter)="showTooltip(i!)" (mouseleave)="hideTooltip()">
          <app-button
            [style]="ButtonStyle.Outlined"
            [size]="ButtonSize.Small"
            [isDisabled]="data.contacts.length === 0"
            [iconOptions]="{
              phosphorClass: 'ph-users',
              iconStyle: Style.fill,
              position: ButtonIcon.OnlyIcon,
            }"
            [noHover]="true"
          ></app-button>

          <app-tooltip [visible]="hoveredTooltipId === i && data.contacts.length > 0" position="left">
            <div [innerHTML]="formatEmails(data.contacts)"></div>
          </app-tooltip>
        </div>
      </td>
    </ng-container>
  </app-base-table>
</div>
